<div
  class="image-preview-wrapper"
  role="dialog"
  [attr.aria-label]="'Image preview'"
  [attr.aria-modal]="true"
>
  <div class="model-close-button">
    <button
      type="button"
      class="btn-close"
      [attr.aria-label]="'Close image preview'"
      (keydown.enter)="$event.preventDefault()"
      (keydown.escape)="close();"
      (click)="close();"
      role="button"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  @if (imageUrl) {
    <div role="region" [attr.aria-label]="'Image content'">
      <img
        [src]="imageUrl"
        width="100%"
        [alt]="imageAlt || 'Preview image'"
        [attr.aria-label]="imageAlt || 'Preview image'"
      />
    </div>
  }
  @if (!imageUrl) {
    <div role="alert" [attr.aria-live]="'polite'">
      <p>Image source is missing.</p>
    </div>
  }
</div>
